import { render } from "./ProjectsComponent.vue?vue&type=template&id=1166a2b2&scoped=true&ts=true"
import script from "./ProjectsComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectsComponent.vue?vue&type=script&lang=ts"

import "./ProjectsComponent.vue?vue&type=style&index=0&id=1166a2b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1166a2b2"]])

export default __exports__